/**
 * Получает расширение файла (включая точку)
 * @param filename - имя файла
 * @returns расширение файла в нижнем регистре (например, ".ts", ".mp4") или пустую строку
 */
export function getFileExtension(filename: string): string {
    const lastDotIndex = filename.lastIndexOf('.');

    if (lastDotIndex === -1 || lastDotIndex === filename.length - 1) {
        return '';
    }

    return filename.slice(lastDotIndex).toLowerCase();
}
